// Vuex
// import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
  return Request('get', "api/food-relations",data);
}


export default {
  fetch,
};